import React from "react";
import clsx from "clsx";

const CommonFormLayout = ({
  header,
  description,
  footer,
  children,
  shadow = true,
  padding = true,
  borderRadius = true,
  border = true,
  divider = true,
  className = "",
}) => {
  return (
    <div
      className={clsx(
        "flex flex-col h-full bg-white transition-shadow relative",
        shadow && "shadow-md hover:shadow-lg",
        borderRadius && "rounded-md",
        border && "border border-black/20",
        padding ? "p-4" : "p-0",
        className,
      )}
    >
      {/* Header */}
      <div
        className={clsx(
          "flex flex-col justify-start items-start sticky top-1 z-10 bg-white",
          padding ? "px-0" : "px-4",
        )}
      >
        <div className="flex items-center gap-2">{header}</div>
        {description && (
          <div className="flex items-center gap-2">{description}</div>
        )}
      </div>

      {/* Header Divider */}
      {divider && <hr className={clsx("border-black/20 my-3")} />}

      {/* Scrollable Content */}
      <div className="flex-grow overflow-auto">{children}</div>

      {/* Footer */}
      {footer && (
        <>
          {divider && (
            <hr
              className={clsx("border-black/20", padding ? "my-4" : "my-2")}
            />
          )}
          <div className="sticky bottom-0 bg-white z-10">{footer}</div>
        </>
      )}
    </div>
  );
};

export default CommonFormLayout;
